 <!--承运商档案>新增>账号信息  -->
<template>
  <div id="account">
    <div class="btns">
      <el-button class="btnItems" v-if="hasPermiss('admin:collecation_account:delCollecationAccount')" @click="delBtns()">删除</el-button>
      <el-button class="btnItems" v-if="hasPermiss('admin:collecation_account:udpateCollecationAccount')" @click="modify()">编辑</el-button>
      <el-button class="btnItems" v-if="hasPermiss('admin:collecation_account:addCollecationAccount')" @click="add()">添加</el-button>
    </div>
    <div class="tablebox">
      <div class="glo_Table">
        <el-table
          :height="tableHeight"
          header-align="center"
          ref="mytable"
          @row-click="rowclick"
          :data="tableData"
          border
          stripe
          :highlight-current-row="true"
          @selection-change="handleSelectionChange"
        >
          <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
          <el-table-column fixed="left" align="center" type="selection" width="60"></el-table-column>
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column v-for="(item, index) in tableHead" :key="index" :label="item.name" :prop="item.field" align="center" :show-overflow-tooltip="true" :min-width="item.width" />
        </el-table>
      </div>
    </div>
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />
    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle" :isShowDialog="isShowDialog" @handleCloseDia="handleCloseDia" @diaCancelBtn="diaCancelBtn" @diaConfirmBtn="diaConfirmBtn">
      <div class="addForm">
        <el-form :model="formdata" ref="addForm" v-if="isShowDialog" :rules="rules" label-width="100px" class="dia_form">
          <el-row :gutter="60">
            <el-col :span="12">
              <el-form-item label="收款人:" prop="accountName">
                <el-input v-model="formdata.accountName" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="回款方式:" prop="refundConfDictId">
                <el-select v-model="formdata.refundConfDictId" placeholder="请选择">
                  <el-option v-for="(item, index) in CollectionArr" :key="index" :label="item.key" :value="item.confDictId" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="60">
            <el-col :span="12">
              <el-form-item label="联系电话:" prop="tel">
                <el-input v-model="formdata.tel" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号码:" prop="phone">
                <el-input v-model="formdata.phone" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="60">
            <el-col :span="12">
              <el-form-item label="银行名称:" prop="bankName">
                <el-input v-model="formdata.bankName" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="银行账号:" prop="bankAccount">
                <el-input v-model="formdata.bankAccount" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="开户行地址:" prop="bankAddress">
                <el-input v-model="formdata.bankAddress" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="60">
            <el-col :span="12">
              <el-form-item label="证件名称:" prop="idcardName">
                <el-input v-model="formdata.idcardName" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="证件号码:" prop="idcardNumber">
                <el-input v-model="formdata.idcardNumber" placeholder="请输入" clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注:" prop="remarks">
                <el-input type="textarea" rows="2" v-model="formdata.remarks" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </my-dialog>
  </div>
</template>
<script >
import myDialog from "@/components/Dialog.vue";
import paging from "@/components/pagings.vue"; //分页组件
export default {
  components: {
    myDialog,
    paging,
  },
  data() {
    return {
      carrierNumber: this.common.carrierNumber,
      CollectionArr: [],
      tableHeight: "75vh", //  表格高度
      tableData: [],
      selectTableData: [],
      tableHead: [
        {
          name: "收款人",
          field: "accountName",
          width: "120",
        },
        {
          name: "联系电话",
          field: "tel",
          width: "120",
        },
        {
          name: "手机号码",
          field: "phone",
          width: "160",
        },

        {
          name: "银行名称",
          field: "frameName",
          width: "120",
        },
        {
          name: "银行账号",
          field: "bankName",
          width: "120",
        },
        {
          name: "开户行地址",
          field: "bankAddress",
          width: "160",
        },
        {
          name: "证件名称",
          field: "idcardName",
          width: "120",
        },
        {
          name: "证件号码",
          field: "idcardNumber",
          width: "120",
        },
        {
          name: "备注",
          field: "remarks",
          width: "120",
        },
      ],
      pageStart: 1,
      pageCount: 0,
      pageTotal: this.$COMMON.pageTotals,
      diaWidth: "50%",
      dialogTitle: null,
      isShowDialog: false,
      defaultFormData: {
        accountName: null,
        bankAccount: null,
        bankAddress: null,
        bankName: null,
        idcardName: null,
        idcardNumber: null,
        phone: null,
        refundConfDictId: null,
        remarks: null,
        tel: null,
      },
      formdata: {
        accountName: "",
        refundConfDictId: "",
        tel: "",
        phone: "",
        bankName: "",
        bankAccount: "",
        bankAddress: "",
        idcardName: "",
        idcardNumber: "",
        remarks: "",
      },
      rules: {},
    };
  },
  props: {
    common: {
      type: Object,
    },
  },

  created() {
    this.GetConfDictValDownList("return_settlement_method");
    this.GetData();
  },
  methods: {
    // 获取收款账号列表
    GetData() {
      let queryData = new Object();
      queryData.pageStart = this.pageStart;
      queryData.pageTotal = this.pageTotal;
      queryData.documentStatus = "carrier_v3:document_status";
      queryData.documentNumber = this.carrierNumber;
      this.$API.CollecationAccountList(queryData).then((res) => {
        if (res.data.status === "success") {
          this.tableData = res.data.result?.data || [];
          this.pageCount = res.data.result?.pageCount || 0;
          // this.$nextTick(() => {
          //   this.fetTableHeight();
          // });
        } else {
          this.$message.error(`${res.data.message}---收款账号列表`);
        }
      });
    },
    // 获取字典数据--回款方式
    GetConfDictValDownList(param) {
      this.$API.getConfDictValDownList({ dictType: param }).then((res) => {
        if (res.data.status === "success") {
          this.CollectionArr = res.data.result || [];
        } else {
          this.$message.error(`${res.data.message}`);
        }
      });
    },
    handleSizeChange(val) {
      this.pageTotal = val;
      this.GetData();
    },
    handleCurrentChange(val) {
      this.pageStart = val;
      this.GetData();
    },
    delBtns(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要删除所选数据吗?", "提示:")
          .then((res) => {
            let delReq = {
              accountIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.accountIds.push(val.accountId);
            });
            this.$API.delCollecationAccount(delReq).then((res) => {
              if (res.data.status === "success") {
                try {
                  let num = 0;
                  let arr = this.tableConfig.tableData;
                  if (delReq.accountIds.length > 2) {
                    delReq.accountIds.map(function (v, i) {
                      num = arr.findIndex((element) => element.accountId == v);
                      arr.splice(num, 1);
                    });
                  } else {
                    num = arr.findIndex(
                      (element) => element.accountId == delReq.accountIds[0]
                    );
                    arr.splice(num, 1);
                  }
                } catch {
                  this.GetData();
                }
                this.$message.success("已删除");
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    modify(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        this.formdata = this.selectTableData[0];
        this.dialogTitle = "修改收款账号";
        this.isShowDialog = true;
      }
    },
    add() {
      this.dialogTitle = "新增收款账号";
      this.isShowDialog = true;
    },

    // 表格
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交

          let param = {};
          for (let key in this.defaultFormData) {
            if (this.formdata[key]) {
              eval("param." + key + "='" + this.formdata[key] + "'");
            } else {
              eval("param." + key + "=''");
            }
          }
          if (this.formdata.accountId) {
            param.accountId = this.formdata.accountId;
          } else {
            param.documentNumber = this.carrierNumber;
            param.documentStatus = "carrier_v3:document_status";
          }
          if (param.accountId && param.accountId !== null) {
            // 修改接口
            this.$API.udpateCollecationAccount(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          } else {
            // 新增接口
            this.$API.addCollecationAccount(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.formdata = {
        accountName: "",
        refundConfDictId: "",
        tel: "",
        phone: "",
        bankName: "",
        bankAccount: "",
        bankAddress: "",
        idcardName: "",
        idcardNumber: "",
        remarks: "",
      };
      this.isShowDialog = false;
    },

    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },
  },
};
</script>
<style scoped lang="less">
#account {
  margin: 40px 40px;
  .btns {
    flex: 1;
    .btnItems {
      border: 1px solid #606266;
      background-color: #fff;
      color: #333;
      padding: 5px 20px;
      margin-left: 10px;
      margin-bottom: 8px;
    }

    .el-button:hover {
      border: 1px solid #ef7c0a;
      color: #ef7c0a;
    }
  }
  .addForm {
    margin: 10px 40px;
  }
  .dia_form {
    .el-form-item {
      margin-bottom: 0px;
      min-width: 260px;
    }
  }
}
</style>
